import React, { useState, useEffect } from 'react';
import { Skeleton } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import classes from './JobList.module.scss';
// eslint-disable-next-line import/no-cycle
import JobCard from '../JobCard/JobCard';
// eslint-disable-next-line import/no-cycle
import JobDetails from '../JobDetails/JobDetails';
import { useWindowSize } from '../../../../utils/hooks';
import { jobsPageSize, responsiveSizeJobs } from '../../../../utils/constants';
import BaseSwipeableDrawer from '../../../common/BaseSwipeableDrawer/BaseSwipeableDrawer';
// eslint-disable-next-line import/no-cycle
import JobDetailsMobile from '../JobDetailsMobile/JobDetailsMobile';

const JobList = (props) => {
  const { jobs, pending, tabs } = props;

  const { width } = useWindowSize();
  const [params] = useSearchParams();
  const actionParam = params.get('action');
  const [sideCard, setSideCard] = useState();

  useEffect(() => {
    if (jobs?.length && !actionParam && width > responsiveSizeJobs) setSideCard(jobs[0]);
    if (!pending && !sideCard && !actionParam && width > responsiveSizeJobs && jobs?.length) setSideCard(jobs[0]);
    if (!pending && !jobs?.length) setSideCard(null);
  }, [pending, jobs]);

  useEffect(() => {
    if (width <= responsiveSizeJobs && actionParam) {
      setSideCard(null);
    }
  }, [params]);

  return (
    <section className={classes.jobsSectionWrapper}>
      <div className={classes.cardsContainer}>
        {pending
          ? Array.from({ length: jobsPageSize }, (v, k) => k).map((item) => (
              <Skeleton
                variant="rectangular"
                key={item}
                width={width > responsiveSizeJobs ? '474px' : '100%'}
                height={width > responsiveSizeJobs ? '130px' : '100px'}
                sx={{ borderRadius: '10px' }}
              />
            ))
          : jobs?.map((job) => (
              <JobCard
                key={job?.Id}
                job={job}
                clickHandler={() => setSideCard(job)}
                isActive={sideCard && job?.Id === sideCard.Id}
                tabTypes={tabs}
              />
            ))}
      </div>
      <div className={classes.cardContainer} style={{ height: `${jobs?.length ? 149.2 * jobs.length : 0}px` }}>
        {sideCard && jobs?.length ? <JobDetails job={sideCard} /> : undefined}
      </div>
      {width <= responsiveSizeJobs && sideCard && jobs?.length && (
        <BaseSwipeableDrawer height="auto" open closeHandler={() => setSideCard(null)}>
          <JobDetailsMobile job={sideCard} />
        </BaseSwipeableDrawer>
      )}
    </section>
  );
};

export default JobList;
